import { v4 as uuidv4 } from 'uuid';

const fetchWithHeaders = async (url, options) => {
  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(`Fetch failed with status: ${response.status}`);
    }

    const headers = new Headers();
    headers.set('Strict-Transport-Security', 'max-age=31536000; includeSubDomains');
    const newResponse = new Response(response.body, {
      status: response.status,
      statusText: response.statusText,
      headers: headers
    });

    return await newResponse.json();
  } catch (error) {
    console.error('Error during fetch:', error);
    throw error;
  }
};

export const getLocalCNAddresses = async () => {
  const url = './config/cnAddresses.json';
  const options = { method: 'GET', mode: 'cors' };

  try {
    return await fetchWithHeaders(url, options);
  } catch (error) {
    console.error('Error fetching local CN addresses:', error);
  }
};

export const getCNAddresses = async () => {
  const url = process.env.getCNAddressesApi;
  const requestHeaders = {
    'Content-Type': 'application/json',
    'X-HSBC-Chnl-CountryCode': 'HK',
    'X-HSBC-Chnl-Group-Member': 'HBAP',
    'X-HSBC-Global-Channel-Id': 'WEB',
    'X-HSBC-Client-Id': 'test',
    'X-HSBC-Source-System-Id': '12648576',
    'X-HSBC-Request-Correlation-Id': uuidv4(),
    'Accept-Language': 'en_GB',
    'X-HSBC-Src-UserAgent': navigator.userAgent,
  };
  const options = {
    method: 'POST',
    mode: 'cors',
    headers: requestHeaders,
    body: JSON.stringify({ data: {} })
  };

  try {
    return await fetchWithHeaders(url, options);
  } catch (error) {
    return await getLocalCNAddresses();
  }
};
